/** Broken-glass assets and the flying fragments of Pixel's crash. */

/**
 * Photographic crack texture (dark cracks on white, impact centred) — an AI regeneration of the
 * client's reference: a jagged impact hole with long radial cracks and sliver wedges to the right.
 * Each crash rotates / mirrors it so repeats look different.
 */
export const CRACK_TEXTURES = [
  'https://cdn.magicpatterns.com/patterns/generated-images/cbfd1ad2-5276-426d-b9e2-5eb82a9701fb.jpg',
];

export interface GlassShard {
  points: string;
  dx: number;
  dy: number;
  rotate: number;
  delay: number;
}

export function seededRandom(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const f = (n: number) => n.toFixed(1);

export function buildShards(seed: number, count = 34): GlassShard[] {
  const rnd = seededRandom(seed ^ 0x9e3779b9);
  return Array.from({ length: count }, () => {
    const s = 3 + rnd() * 13;
    const n = rnd() < 0.5 ? 3 : 4;
    const pts = Array.from({ length: n }, (_, k) => {
      const a = (k / n) * Math.PI * 2 + rnd() * 1.1;
      const r = s * (0.45 + rnd() * 0.7);
      return `${f(Math.cos(a) * r)},${f(Math.sin(a) * r)}`;
    });
    const a = rnd() * Math.PI * 2;
    const dist = 60 + rnd() * 300;
    return {
      points: pts.join(' '),
      dx: Math.cos(a) * dist,
      dy: Math.sin(a) * dist * 0.6 + 140 + rnd() * 220, // flies out, then falls
      rotate: (rnd() - 0.5) * 900,
      delay: rnd() * 0.05,
    };
  });
}
